import React from "react";
import LinkedinSVG from "../../assets/icons/linkedin.svg";

import "./LinkedinButton.scss";

const LinkedinButton = () => (
	<a
		href="https://www.linkedin.com/company/botwise/"
		rel="noopener noreferrer"
		target="_blank"
		className="linkedin-logo"
	>
		<LinkedinSVG />
	</a>
);

export default LinkedinButton;
